import o, { css as i } from "styled-components";
import { STATUS_COLOR as I } from "../../../constants/status.es.js";
import { helper as t } from "./helper.es.js";
import { IconButton as w } from "../Button/IconButton.es.js";
import { Icon as e } from "../../DataDisplay/Icon/Icon.es.js";
const P = o.div.withConfig({
  displayName: "Menu",
  componentId: "sc-1ix8fhc-0"
})(["align-items:center;display:flex;gap:var(--size-gap-2);height:28px;margin:12px 16px;width:calc(100% - 4px);"]);
var b;
const x = o(w).withConfig({
  displayName: "MenuButton",
  componentId: "sc-1ix8fhc-1"
})(["min-width:auto;opacity:0.5;position:relative;text-decoration:none;&:hover{opacity:1;}", "{fill:var(--color-bg-stronger);}"], (b = e.S) == null ? void 0 : b.Icon), W = o.div.withConfig({
  displayName: "MenuPrefixes",
  componentId: "sc-1ix8fhc-2"
})(["margin-right:14px;"]);
var h, v;
const u = o.button.withConfig({
  displayName: "MenuPrefixesItem",
  componentId: "sc-1ix8fhc-3"
})(["align-items:center;background:var(--color-bg-default);border:1px solid rgba(38,67,118,0.5);border-radius:var(--size-components-input-border-radius-md);color:var(--color-bg-stronger);display:flex;height:28px;justify-content:center;opacity:0.5;padding:0 8px 0 4px;&:hover{border:1px solid var(--color-bg-stronger);opacity:1;}", "{fill:var(--color-bg-stronger);}"], (v = (h = e) == null ? void 0 : h.S) == null ? void 0 : v.Icon), L = o.div.withConfig({
  displayName: "Editor",
  componentId: "sc-1ix8fhc-4"
})(["", " .editor-mini .ProseMirror{padding-top:8px;}.ProseMirror > * + *{margin-top:16px;}kbd,code{border-radius:4px;box-decoration-break:clone;font-size:14px;padding:4px;}"], ({
  status: r,
  isFocused: n,
  hasValue: y
}) => {
  var a, p, d, c, s, l, m, g, f;
  return i(["border:1px solid var(--color-components-input-border-default);border-radius:var(--size-components-input-border-radius-md);position:relative;width:100%;", "{color:", ";", "}", " ", " .ProseMirror{height:140px;overflow-y:scroll;padding:8px 8px 8px 16px;p{margin-top:0;}a{color:var(--color-blue-900);}ul,ol{margin:1.25rem 1rem 1.25rem 0.4rem;padding:0 1rem;li p{margin-bottom:0.25em;margin-top:0.25em;}}ul li{list-style-type:disc;}ol li{list-style-type:decimal;}}.ProseMirror-focused{outline:none;}"], C, (a = t.getStatusColor(r)) == null ? void 0 : a.color, (n || y) && i(["top:0;transform:translateY(-12px);"]), r === I.success && i(["border:", ";", "{border:1px solid var(--color-bg-stronger);opacity:1;}", "{opacity:1;", "{fill:var(--color-accent-primary-default);}}"], (c = (d = (p = t) == null ? void 0 : p.getStatusColor(r)) == null ? void 0 : d.focus) == null ? void 0 : c.border, u, x, (s = e.S) == null ? void 0 : s.Icon), n && r !== "error" && i(["border:", ";", "{border:1px solid var(--color-bg-stronger);opacity:1;}", "{opacity:1;", "{fill:var(--color-accent-primary-default);}}"], (g = (m = (l = t) == null ? void 0 : l.getStatusColor(r)) == null ? void 0 : m.focus) == null ? void 0 : g.border, u, x, (f = e.S) == null ? void 0 : f.Icon));
}), C = o.div.withConfig({
  displayName: "Label",
  componentId: "sc-1ix8fhc-5"
})(["background-color:var(--color-components-input-bg-default);margin-left:calc(var(--size-components-input-height-md) / 2.5);position:absolute;top:10px;transition:all 0.2s ease-in-out;z-index:1;"]), E = o.span.withConfig({
  displayName: "Required",
  componentId: "sc-1ix8fhc-6"
})(["color:var(--color-error-default);"]), T = o.div.withConfig({
  displayName: "LinkWrapper",
  componentId: "sc-1ix8fhc-7"
})(["background-color:var(--color-components-input-bg-default);border:1px solid var(--color-border-default);border-radius:var(--size-border-radius-md);bottom:40px;left:100px;padding:var(--size-padding-8);position:absolute;z-index:1;"]), j = o.div.withConfig({
  displayName: "LinkInputWrapper",
  componentId: "sc-1ix8fhc-8"
})(["display:flex;gap:var(--size-gap-8);margin-top:var(--size-8);"]), B = o.div.withConfig({
  displayName: "TextEditorWrapper",
  componentId: "sc-1ix8fhc-9"
})(["position:relative;"]), R = o.div.withConfig({
  displayName: "EmojiWrapper",
  componentId: "sc-1ix8fhc-10"
})(["position:absolute;right:30px;z-index:1000;.epr-header{display:none;}"]);
export {
  L as Editor,
  R as EmojiWrapper,
  C as Label,
  j as LinkInputWrapper,
  T as LinkWrapper,
  P as Menu,
  x as MenuButton,
  W as MenuPrefixes,
  u as MenuPrefixesItem,
  E as Required,
  B as TextEditorWrapper
};
//# sourceMappingURL=style.es.js.map
